import axios from "./axios-auth";

const insertLoginsOrdersReport = (data, params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/getloginorderreport",
      params: params,
      data: data,
      method: "POST",
    }).then((resp) => {
      if (resp.status !== 200) {
        reject(resp.data.message);
      }
      console.log(resp, " from insert login order report api");
      resolve(resp);
    });
  });

const insertLoginsOrdersReportExcel = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "hr-adm/getloginorderreport",
      params: {
        pg_num: 1,
        pg_size: 10,
      },
      data: params,
      method: "POST",
      responseType: "blob",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        console.log(resp, " from insert login order report api");
        resolve(resp);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from insert login order report api");
      });
  });

const insertAuthorizedClient = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getauthorizedclients",
      params: "",
      method: "GET",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        console.log(resp, " from getauthorizedclients api");
        resolve(resp);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from getauthorizedclients api");
      });
  });

const insertUserLogs = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/insertuserlog",
      method: "POST",
      params: params,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          throw new Error(resp.data.message);
        }
        console.log(resp, " from insertUserLogs api");
        resolve(resp);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from insertUserLogs api");
      });
  });

export {
  insertLoginsOrdersReport,
  insertLoginsOrdersReportExcel,
  insertAuthorizedClient,
  insertUserLogs,
};
